import { decodeFromBase64 } from "../utils";
export class User {
    constructor(oauth2Token) {
        this._claims = JSON.parse(decodeFromBase64(oauth2Token.access_token.split(".")[1]));
        if ("sub" in this._claims) {
            this._id = this._claims.sub;
        }
        else if ("userId" in this._claims) {
            this._id = this._claims.userId;
        }
        else {
            throw new Error("no sub or userId claim found!");
        }
        if ("authorities" in this._claims) {
            const authorities = this._claims.authorities;
            this._roles = authorities
                .filter((authority) => authority.startsWith("ROLE_"))
                .map((authority) => authority.substring("ROLE_".length));
        }
        else {
            this._roles = [];
        }
        this._capabilities = [];
        if ("licenses" in this._claims) {
            this._licenses = this._claims.licenses;
        }
        else {
            this._licenses = ["freetrial"];
        }
    }
    get id() {
        return this._id;
    }
    get roles() {
        return this._roles;
    }
    get claims() {
        return this._claims;
    }
    get licenses() {
        return this._licenses;
    }
    get capabilities() {
        return this._capabilities;
    }
}
//# sourceMappingURL=IMember.js.map